<template>
  <validation-observer ref="observer" v-slot="slot">
    <form @submit.prevent="slot.handleSubmit(submit)">
      <slot v-bind="slot" />
    </form>
  </validation-observer>
</template>

<script>
export default {
  name: "validable-form",

  methods: {
    submit() {
      this.$emit("submit");
    },

    reset() {
      this.$refs.observer.reset();
    }
  }
};
</script>

<style></style>
